export default {
  courierInfoColor: Styles.color.black,
  contactPromptColor: '',
  contactInfoColor: Styles.color.black,
  iconXFill: Styles.color.black,
  statusMessageColor: '',
};
